import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
export default {
  name: "community-tag",
  data: function data() {
    return {
      searchForm: {
        page: 1,
        limit: 20,
        name: ""
      },
      // 搜索表单

      form: {},
      dialogVisible: false,
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      rules: {
        name: [{
          required: true,
          message: "请输入标签名称",
          trigger: "blur"
        }]
      },
      categoryList: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            setTimeout(function () {
              _this.getCategoryList();
            }, 300);
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    getCategoryList: function getCategoryList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.getCommunityCategoryList({
                page: 1,
                limit: 100
              });
            case 1:
              res = _context2.v;
              _this2.categoryList = res.data.list;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    pageChange: function pageChange(pn) {
      this.searchForm.page = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (type === "search") {
                _this3.searchForm.page = 1;
              }
              _this3.tableLoading = true;
              _context3.n = 1;
              return _this3.$api.getCommunityCategoryList(_this3.searchForm);
            case 1:
              res = _context3.v;
              _this3.tableData = res.data.list;
              _this3.total = res.data.count;
              _this3.tableLoading = false;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    updateSort: function updateSort(row) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this4.$api.sortLifestyleTag(row);
            case 1:
              _this4.$message.success("操作成功");
              _this4.getData();
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    updateDialog: function updateDialog(row) {
      this.form = Object.assign({}, row);
      this.dialogVisible = true;
    },
    save: function save() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _this5.$refs["form"].validate(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(valid) {
                  return _regenerator().w(function (_context5) {
                    while (1) switch (_context5.n) {
                      case 0:
                        if (!valid) {
                          _context5.n = 4;
                          break;
                        }
                        if (!_this5.form.id) {
                          _context5.n = 2;
                          break;
                        }
                        _context5.n = 1;
                        return _this5.$api.updateCommunityTag(_this5.form);
                      case 1:
                        _context5.n = 3;
                        break;
                      case 2:
                        _context5.n = 3;
                        return _this5.$api.addCommunityTag(_this5.form);
                      case 3:
                        _this5.dialogVisible = false;
                        _this5.form = {};
                        _this5.getData();
                      case 4:
                        return _context5.a(2);
                    }
                  }, _callee5);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    close: function close() {
      this.$refs["form"].clearValidate();
    },
    deleteItem: function deleteItem(row) {
      var _this6 = this;
      this.$confirm("删除， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return _this6.$api.deleteCommunityTag(row.id);
            case 1:
              _this6.$message.success("删除成功！");
              _this6.getData();
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))).catch(function () {});
    }
  }
};